function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPartner7(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 207.1664,
    height: 61.88665,
    viewBox: "0 0 54.812773 16.374176",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "layer1",
    transform: "translate(-66.948993,-156.00435)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g14189",
    transform: "translate(0.26458445,-0.26457685)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path14179",
    d: "m 92.701347,160.49467 h 2.454628 v 7.92198 h -1.818922 v -5.3273 l -2.326923,5.3273 -2.448983,-5.334 v 5.334 h -1.697214 v -7.92198 h 2.426053 l 1.749072,4.10034 z",
    style: {
      fill: "#231f20",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.35277778
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path14177",
    d: "m 96.060497,160.49467 v 7.92198 h 4.570943 v -1.34303 H 97.8325 v -2.01542 h 2.68323 v -1.35572 H 97.8325 v -1.81751 h 2.79894 v -1.3903 z",
    style: {
      fill: "#231f20",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.35277778
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path14175",
    d: "m 107.44887,164.45707 c 0,2.94887 3.07763,5.3086 6.32037,3.73027 v -1.69721 c -2.4952,1.74801 -4.66725,-0.004 -4.63162,-1.96533 0.0243,-1.30351 0.90028,-2.54317 2.59468,-2.63983 0.83326,-0.0473 1.3977,0.15981 2.03694,0.77187 v -1.76494 c -2.34315,-1.38854 -6.32037,0.1397 -6.32037,3.56517",
    style: {
      fill: "#231f20",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.35277778
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path14173",
    d: "m 114.51712,168.41665 h 1.68487 v -7.84578 h -1.68487 z",
    style: {
      fill: "#231f20",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.35277778
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path14171",
    d: "m 118.31619,164.1685 2.546,-3.58034 h -1.9678 l -2.52236,3.57363 2.92841,4.25486 h 1.93216 z",
    style: {
      fill: "#231f20",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.35277778
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path14169",
    transform: "scale(0.26458333)",
    d: "m 383.31641,606.59375 v 29.94141 h 6.7207 v -16.08594 l 11.10937,16.08594 h 7.16407 l -8.79493,-12.57227 c 4.076,-1.54137 5.39844,-4.95902 5.39844,-8.375 0,-3.41337 -2.86531,-8.99414 -9.80664,-8.99414 z m 6.7207,4.98242 h 2.93359 c 4.9598,0 5.22461,3.24243 5.22461,4.45313 0,2.31329 -1.96275,4.2832 -4.49609,4.2832 h -3.66211 z",
    style: {
      fill: "#231f20",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 1.33333337
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 70.909982,160.49485 c 0,-2.18793 1.773767,-3.96134 3.961342,-3.96134 2.18828,0 3.961341,1.77341 3.961341,3.96134 z m 0,7.92233 c 0,-2.18757 1.773767,-3.96134 3.961342,-3.96134 -2.187575,0 -3.961342,-1.77306 -3.961342,-3.96099 -2.187575,0 -3.960989,1.77341 -3.960989,3.96099 0,2.18828 1.773414,3.96134 3.960989,3.96134 m 0,0 c 0,2.18828 1.773767,3.96134 3.961342,3.96134 2.18828,0 3.961341,-1.77306 3.961341,-3.96134 z m 3.961342,-3.96134 c 2.18828,0 3.961341,1.77377 3.961341,3.96134 2.187928,0 3.961695,-1.77306 3.961695,-3.96134 0,-2.18758 -1.773767,-3.96099 -3.961695,-3.96099 0,2.18793 -1.773061,3.96099 -3.961341,3.96099",
    style: {
      fill: "#007a73",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none",
      strokeWidth: 0.35277778
    },
    id: "path13366"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPartner7);
export default __webpack_public_path__ + "static/media/partner7.00430dad8e880824f3a467232006c96c.svg";
export { ForwardRef as ReactComponent };